import React, {type Dispatch, useEffect} from 'react';

import type {PaginatedListProps} from './PaginatedList';

interface PaginatedPageProps<P, D> extends PaginatedListProps<P, D> {
  page: number;
  setHasNext: Dispatch<React.SetStateAction<undefined | null | string>>;
  setIsLoading: (page: number, isLoading: boolean) => unknown;
  removePage: (page: number) => unknown;
}

export const PaginatedPage = <P, D>({
  hook,
  page,
  params,
  render,
  setHasNext,
  setIsLoading,
  removePage,
}: PaginatedPageProps<P, D>) => {
  const {data, isError, isLoading} = hook({...params, page});

  useEffect(() => {
    if (data) {
      setHasNext(data?.next);
    }
  }, [data]);

  useEffect(() => {
    if (isError) {
      removePage(page);
    }
  }, [isError]);

  useEffect(() => {
    setIsLoading(page, isLoading);
  }, [isLoading]);

  return render(data);
};
